export default "__VITE_ASSET__CBwzYJiP4eng85dhr_jjHQ__"